module.exports = __webpack_public_path__ + "static/media/1.49012721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/code/1.jpg
// module id = 492
// module chunks = 0